import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Icon from '../../../../../../atoms/Icon'

const NonBillableCell = ({ value }) => {
  if (!value) return null

  return (
    <Box style={{ textAlign: 'center' }}>
      <Icon name='check' color='var(--color-success-500)' customSize={18} />
    </Box>
  )
}

NonBillableCell.propTypes = {
  value: PropTypes.any
}

export default NonBillableCell
